import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ContextMenuItem/ContextMenuItem.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { MenuItem as MenuItemInit, ListItemIcon as ListItemIconInit } from '@mui/material';
import { ExpandLess as ExpandLessInit } from '@mui/icons-material';
export var Divider = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 1px;\n  width: calc(100% - 32px);\n  padding: 0 16px;\n  background: #e5e7f1;\n  margin: 6px auto;\n"])));
export var MenuItem = styled(MenuItemInit)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: normal;\n  font-size: 16px;\n  letter-spacing: 0.1px;\n  color: #000335;\n  transition: none;\n\n  &:hover {\n    background: rgba(53, 59, 96, 0.05);\n  }\n"])));
export var ListItemIcon = styled(ListItemIconInit)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  justify-content: center;\n\n  path {\n    fill: #353b60;\n  }\n"])));
export var ExpandLess = styled(ExpandLessInit)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 20px;\n"])));